const initialState = {
  cid: null,
  startDate: null,
  endDate: null, 
}

export default function calendarReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_CALENDAR':
      return {
        ...state,
        cid: action.payload.cid,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate
      }
    default:
      return state;
  }
}
